module.exports = __webpack_public_path__ + "media/components/country-flag/static/mw-90ea98079c76d11d45dd4f82a7ac801e.svg";